import { FilesService } from 'src/app/services/shared/files/files.service';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ngx-dov-viewer',
  templateUrl: './ngx-dov-viewer.component.html',
  styleUrls: ['./ngx-dov-viewer.component.scss'],
  providers: [FilesService]
})
export class NgxDovViewerComponent implements OnInit, OnChanges {

  @Input() cdnPath;
  @Input() hasDocument;
  @Input() enable_signed_url;
  signed_url;
  loaded: boolean;
  refreshDocument: boolean = false;
  fetching_attachments: boolean = true;
  @Input() google_container_url_document = '';
  constructor(
    private file_srv: FilesService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.cdnPath && this.cdnPath != '') {

      }
      else {
        this.cdnPath = null;
      }
    }, 5000)
  }
  ngOnChanges(ev: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (ev && ev.hasDocument) {
      this.hasDocument = ev.hasDocument.currentValue;
      if (this.hasDocument) {
        this.fetching_attachments = true;
      }
      else {
        this.fetching_attachments = false;
      }
    }
    if (ev && ev.cdnPath) {
      this.cdnPath = ev.cdnPath.currentValue;
      if (this.cdnPath) {
        this.fetching_attachments = true;
        if (this.enable_signed_url) {
          this.file_srv.getURL(this.cdnPath).subscribe(res => {
            if (res && res['data']) {
              this.signed_url = res['data'].url
            }
          })
        }
      }
      setTimeout(() => {
        if (!this.loaded) {
          this.refreshDocument = true;
          setTimeout(() => {
            this.refreshDocument = false;
          })
        }
      }, 10000)
    }
  }
  contentLoaded() {
    this.loaded = true;
    this.fetching_attachments = false;
    console.log('loaded')
  }
  reloading(ev) {
    console.log(ev)
  }

}
